import type { FlagKey, FlagValue } from '@src/service/feature-flags'

import Repository from './base'

export class KeyValueRepository extends Repository<Record<string, FlagValue<FlagKey>>> {}
